import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';
import {FundSwitchingComponent} from "./components/fund-switching.component";


const routes = [{
  path: "fund-switching",
  component: FundSwitchingComponent,
  canActivate: [CanActivateViaAuthGuard]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class FundSwitchingRoutingModule {
}
